import React from 'react'
import PropTypes from 'prop-types'
import { languageController } from '../../../../controllers/language/languageController'
import CalloutBoxShort from '../../../2_Molecules/CalloutBox/CalloutBoxShort';

function ConfirmationStep_BaSA({
  contactDetails,
  vehicleData,
  dealerData,
  dateAndTimeData
}) {
  const { dealer, userPosition } = dealerData || {};

  return (
    <div className="mz-confirmation-step-basa">
      <div className="mz-container">
        <div className="grid-inner-content-wide mz-confirmation-step-basa__top">
          <h3>{languageController.getCopy('confirmationStep', 'title')}, {contactDetails?.firstname}!</h3>
          <p className="m-b-0">{languageController.getCopy('confirmationStep', 'subTitle')}</p>
        </div>
        <div className="grid-inner-content mz-confirmation-step-basa__callout">
          <CalloutBoxShort
            vehicleData={vehicleData}
            dealerData={dealer}
            userPosition={userPosition}
            dateAndTimeData={dateAndTimeData}
            isOwnVehicleType={true}
          />
        </div>
      </div>
    </div>
  )
}

ConfirmationStep_BaSA.propTypes = {
  contactDetails: PropTypes.object,
  vehicleData: PropTypes.object,
  dealerData: PropTypes.object,
  dateAndTimeData: PropTypes.object
}

export default ConfirmationStep_BaSA

